import {isDate, isEqualWith, omitBy, startsWith} from 'lodash';
import moment from 'moment';

const dateComparator = (a: any, b: any): boolean | undefined => {
    if (moment.isMoment(a) || moment.isMoment(b) || isDate(a) || isDate(b)) {
        return moment(a).valueOf() === moment(b).valueOf();
    }
    return undefined;
};

const getValuesWithoutTempData = (values: any, tempDataPrefix: string) => omitBy(values, (value, key) => startsWith(key, tempDataPrefix));

const isEqualValues = (values: any, initialValues: any, excludeTempData = false, tempDataPrefix = '__') => {
    if (!excludeTempData) {
        return isEqualWith(values, initialValues, dateComparator);
    }
    const filteredValues = getValuesWithoutTempData(values, tempDataPrefix);
    const filteredInitialValues = getValuesWithoutTempData(initialValues, tempDataPrefix);
    return isEqualWith(filteredValues, filteredInitialValues, dateComparator);
};

export const dataUtils = {
    isEqualValues
};
